"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupDetailContent = exports.GroupDetailPage = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const GroupInfoCard_1 = require("./cards/GroupInfoCard");
const GroupUsersCard_1 = require("./cards/GroupUsersCard");
const useFindGroup_1 = require("./hooks/useFindGroup");
const StyledGrid = (0, styled_components_1.default)(core_1.Grid) `
  flex: 1;
  .grid-flex,
  .card-flex,
  .card-content-flex {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;
const GroupDetailPage = () => {
    const { groupId: paramGroupId = '' } = (0, react_router_dom_1.useParams)();
    const groupId = parseInt(paramGroupId) || 0;
    const [group, setGroup] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const [didUpdate, setDidUpdate] = (0, react_1.useState)(false);
    const { group: foundGroup, error: findError, get } = (0, useFindGroup_1.useFindGroup)(groupId);
    (0, react_1.useEffect)(() => {
        setGroup(foundGroup);
    }, [foundGroup]);
    (0, react_1.useEffect)(() => {
        setError(findError);
    }, [findError]);
    return (react_1.default.createElement(core_ui_1.PageTemplate, null,
        react_1.default.createElement(core_ui_1.PageTemplateHeader, null,
            react_1.default.createElement("h2", null, "Group Detail")),
        react_1.default.createElement(core_ui_1.PageTemplateDashboard, null, group && react_1.default.createElement(exports.GroupDetailContent, { group: group, onChange: () => get() })),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'success', open: didUpdate, onClose: () => setDidUpdate(false) }, "Group details updated."),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!error, onClose: () => setError(undefined) }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')));
};
exports.GroupDetailPage = GroupDetailPage;
exports.default = exports.GroupDetailPage;
const GroupDetailContent = props => {
    const { group, onChange, handleUserRedirect } = props;
    return (react_1.default.createElement(StyledGrid, { container: true, spacing: 3 },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 12, className: 'grid-flex' },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(GroupInfoCard_1.GroupInfoCard, { group: group, onChange: onChange })),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(GroupUsersCard_1.GroupUsersCard, { groupId: group.id, onRowClick: handleUserRedirect }))))));
};
exports.GroupDetailContent = GroupDetailContent;
//# sourceMappingURL=GroupDetailPage.js.map